"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.nodata = 'dropdowns.nodata';
/**
 * @hidden
 */
exports.clear = 'dropdowns.clear';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.clear] = 'clear',
    _a[exports.nodata] = 'NO DATA FOUND.',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dropdowns@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_re_vkmwb4tr3wvnf7qdjhi25kjvza/~/@progress/kendo-react-dropdowns/dist/npm/messages/index.js
// module id = 323
// module chunks = 0